import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Hero } from "@/components/landing/Hero";
import { TrustBar } from "@/components/landing/TrustBar";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { FeatureDeepDive } from "@/components/landing/FeatureDeepDive";
import { Testimonials } from "@/components/landing/Testimonials";
import { Stats } from "@/components/landing/Stats";
import { FAQ } from "@/components/landing/FAQ";
import { CTASection } from "@/components/landing/CTASection";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function Landing() {
  // Use default title and description for landing page
  useDocumentMeta({});
  
  const location = useLocation();
  
  // Scroll to hash anchor on page load
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location.hash]);
  return (
    <div className="min-h-screen bg-background">
      {/* 1. Header (sticky, transparent → solid on scroll) */}
      <Header />
      
      <main>
        {/* 2. Hero Section - Full-width gradient, headline, CTA, product visual */}
        <Hero />
        
        {/* 3. Trust Bar - "Trusted by" with company badges */}
        <TrustBar />
        
        {/* 4. Features Grid - 6 key features with icons */}
        <Features />
        
        {/* 5. How It Works - 3 steps with visuals */}
        <HowItWorks />
        
        {/* 6. Feature Deep-Dive - Alternating left/right sections */}
        <FeatureDeepDive />
        
        {/* 7. Testimonials - Customer quotes */}
        <Testimonials />
        
        {/* 8. Stats Section - Large numbers with context */}
        <Stats />
        
        {/* 9. FAQ Section - Accordion */}
        <FAQ />
        
        {/* 10. CTA Section - Final conversion push */}
        <CTASection />
      </main>

      {/* 11. Footer */}
      <Footer />
    </div>
  );
}
